import React from 'react';

const redGradient = '#dc2626';
const cardBg = '#111';
const cardBorder = '#1f1f1f';
const cardBorderSelected = 'rgba(220,38,38,0.4)';

function AlbumCard({ item, isSelected, onSelect, onEdit, onDelete, viewMode }) {
  const formatDuration = (seconds) => {
    if (!seconds) return '--:--';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const initial = item.title?.charAt(0).toUpperCase() || 'A';

  if (viewMode === 'list') {
    return (
      <div
        className="flex items-center justify-between p-4 rounded-xl transition-all"
        style={{ background: cardBg, border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}` }}
      >
        <div className="flex items-center gap-4">
          <input type="checkbox" checked={isSelected} onChange={onSelect} className="w-4 h-4 rounded" style={{ accentColor: '#dc2626' }} />
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0" style={{ background: redGradient }}>
              {item.cover_image_url ? (
                <img src={item.cover_image_url} alt={item.title} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <span className="text-white font-black text-lg">{initial}</span>
                </div>
              )}
            </div>
            <div>
              <h3 className="font-bold text-white text-sm">{item.title}</h3>
              <div className="flex items-center gap-3 mt-0.5">
                <span className="text-xs" style={{ color: '#9ca3af' }}>{item.artist?.name || 'Unknown Artist'}</span>
                {item.release_year && <span className="text-xs font-mono" style={{ color: '#6b7280' }}>{item.release_year}</span>}
                <span className="text-xs" style={{ color: '#6b7280' }}>{item.songs?.length || 0} tracks</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <button onClick={onEdit} className="px-3 py-1.5 rounded-lg text-xs font-medium text-white" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>Edit</button>
          <button onClick={onDelete} className="px-3 py-1.5 rounded-lg text-xs font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>Delete</button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="relative rounded-xl overflow-hidden transition-all group"
      style={{ background: cardBg, border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}` }}
    >
      <div className="absolute top-3 left-3 z-10">
        <input type="checkbox" checked={isSelected} onChange={onSelect} className="w-4 h-4 rounded" style={{ accentColor: '#dc2626' }} />
      </div>

      <div className="relative aspect-square overflow-hidden" style={{ background: redGradient }}>
        {item.cover_image_url ? (
          <img src={item.cover_image_url} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-white font-black text-5xl opacity-80">{initial}</span>
          </div>
        )}
        {item.release_year && (
          <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded text-xs font-mono font-bold text-white" style={{ background: 'rgba(0,0,0,0.8)' }}>
            {item.release_year}
          </div>
        )}
      </div>

      <div className="p-4">
        <h3 className="font-black text-white text-sm truncate mb-1">{item.title}</h3>
        <p className="text-xs truncate mb-3" style={{ color: '#9ca3af' }}>{item.artist?.name || 'Unknown Artist'}</p>
        <div className="flex items-center justify-between text-xs mb-4" style={{ color: '#6b7280' }}>
          <span>{item.songs?.length || 0} tracks</span>
          <span className="font-mono">{formatDuration(item.total_duration)}</span>
        </div>
        <div className="flex gap-2">
          <button onClick={onEdit} className="flex-1 py-2 rounded-lg text-xs font-medium text-white" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>Edit</button>
          <button onClick={onDelete} className="flex-1 py-2 rounded-lg text-xs font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>Delete</button>
        </div>
      </div>
    </div>
  );
}

export default AlbumCard;